import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Link, ListItem, f7 } from 'framework7-react';
import { setShowMainInfoPopUp } from '../../redux/actions/rootAction';
import II18 from '../translate/II18';

/** Template/request setting: start page hidden (embed uses skipStartPageOriginal). */
export function startPageHiddenBySettings({
  skipStartPage,
  skipStartPageOriginal
} = {}) {
  return Boolean(skipStartPageOriginal ?? skipStartPage);
}

function OpenMainInfoLink(props) {
  const {
    setShowMainInfoPopUp: openMainInfo,
    style,
    className,
    children
  } = props;

  return (
    <Link
      id={'openInfoPopup'}
      className={className}
      style={style}
      onClick={() => openMainInfo(true)}
    >
      {children || (
        <>
          <label className={'screenreader'}>Information</label>
          <Icon size="25" icon="fas fa-info-circle" />
        </>
      )}
    </Link>
  );
}

OpenMainInfoLink.propTypes = {
  setShowMainInfoPopUp: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
};

function OpenMainInfoMenuItemComponent(props) {
  const { setShowMainInfoPopUp: openMainInfo } = props;

  return (
    <ListItem
      id={'itemOpenMainInfo'}
      popoverClose
      title={II18.get('title_information')}
      onClick={() => {
        f7.popover.close();
        setTimeout(() => openMainInfo(true), 100);
      }}
    >
      <Icon slot="after" icon="fas fa-info-circle" />
    </ListItem>
  );
}

OpenMainInfoMenuItemComponent.propTypes = {
  setShowMainInfoPopUp: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  setShowMainInfoPopUp: opened => dispatch(setShowMainInfoPopUp(opened))
});

export const OpenMainInfoMenuItem = connect(
  null,
  mapDispatchToProps
)(OpenMainInfoMenuItemComponent);

export default connect(null, mapDispatchToProps)(OpenMainInfoLink);
